export const FORM_ELEMENT_ID = 'page-payment-profile';
